export type ValueOf<T> = T[keyof T]

export type StringToLiteral<T> = {
	[K in keyof T]: K extends K ? K : never
}

export type FormFieldChoice = { value: string; label: string }

export type FindManyArgs<TWhere, TOrderBy = unknown> = {
	where?: TWhere
	orderBy?: TOrderBy
	page?: number
}

export type SearchParams = Record<string, string>

export type AttachmentData = { name: string; url: string | null; id: string }

export interface EntityPageProps<T extends object = object> {
	params: { id: string } & T
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FetchReturn<T extends (args?: any) => unknown> = Awaited<ReturnType<T>>
export type ActionReturnErrorType = { error: string }
export type ActionReturnSuccessType<T> = { id: number; data?: T } | void
export type ActionReturnType<T = unknown> = Promise<ActionReturnErrorType | ActionReturnSuccessType<T>>
export function hasActionFailed<T extends Awaited<ActionReturnType<T>>>(
	result: { error: string } | { id: number } | T,
): result is { error: string } {
	return typeof result === 'object' && 'error' in result
}
export function hasActionSucceeded<T>(result: { error: string } | { id: number; data?: T } | void): result is { id: number; data: T } {
	return typeof result === 'object' && 'id' in result && result.data !== undefined
}
